var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/retry';
import { Observable } from 'rxjs/Observable';
import * as socketIo from 'socket.io-client';
var SocketIo = /** @class */ (function () {
    function SocketIo() {
    }
    SocketIo.prototype.ngOnInit = function () {
    };
    SocketIo.prototype.somemethod = function () {
        var _this = this;
        var observable = new Observable(function (observer) {
            var token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiNWEwZDVlYWIyYzViYzkyMzI1YjFhNTAxIiw' +
                'idG9rZW4iOiI0OWQwODk4YTQ1M2UwNTI4NmQwMWFhMmI1MTA3YmQ1NDY4YTc1NjA1ZTQ1MjU0NzI5MjQzNWI2MGRjZGRmNDhmNz' +
                'dlZDg0ODg5OTg5YWJhYzA5MjJhYTRiNTFjZGViNWQiLCJpYXQiOjE1MTA4MjU2NDR9.nwvL0RwglKmjNGgIqHPu5FSgJ-Zb9DOOTvkwi2nw_f4';
            _this.socket = socketIo('http://localhost:3002', { query: 'token=' + token });
            // socket.on('hello', (data) => console.log(data));
            _this.socket.on('connect', function () {
                // console.log('socket connected');
                // socket.emit('join', 'Hello World from client');
            });
            _this.socket.on('productAdd', function (data) {
                // console.log('product added', JSON.stringify(data));
                observer.next(data);
            });
        });
        return observable;
    };
    SocketIo = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], SocketIo);
    return SocketIo;
}());
export { SocketIo };



//////////////////
// WEBPACK FOOTER
// ./src/app/user/socket.io.ts
// module id = ./src/app/user/socket.io.ts
// module chunks = main